
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fitness-app",
      function () {
        return require("private-next-pages/fitness-app.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fitness-app"])
      });
    }
  